<template>
    <div>
        <v-row class="mb-0">
            <v-col style="position: relative">
                <v-select class="mb-2" hide-details solo label="Første række" v-model="firstRow" :items="filteredRows['firstRow']" />
                <v-select hide-details solo label="Anden række" v-model="secondRow" :items="filteredRows['secondRow']" />
                <v-btn class="switch-rows-button white--text" fab small @click="switchRows" color="third">
                    <v-icon size="medium">
                        fa-sync-alt
                    </v-icon>
                </v-btn>            
            </v-col>                        
            <v-col>
                <range-picker :solo="true" storeName="naestved" rangeName="range" periodName="period" :presets="$store.state.naestved.presets" />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="3" v-for="({ header, value, formatter }, index) in totalCards" :key="index">
                <total-card :header="header" :value="value(totals)" :formatter="formatter" :loading="loading" />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <loader v-if="loading" />
                    <sales-pivot v-else
                        defaultSort="avgLead"
                        :dataObject="stats"
                        :fields="fields"
                        :nestedFields="nestedFields"
                        :valueFunctions="valueFunctions" />
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import TotalCard from '@/components/totalCard.vue'
import SalesPivot from '@/components/salesPivot.vue'
import RangePicker from '@/components/rangePicker.vue'

export default {
    components: {
        SalesPivot,
        RangePicker,
        TotalCard
    },
    data () {
        return {
            loading: true,
            firstRow: 'UserFirstProcessedBy.Name',
            secondRow: 'Campaign.Name',
            rows: [
                {
                    text: 'Sælger',
                    value: 'UserFirstProcessedBy.Name'
                },
                {
                    text: 'Kampagne',
                    value: 'Campaign.Name'
                }
            ],
            totalCards: [
                {
                    header: 'Afsluttede',
                    formatter: this.$options.filters.separator,
                    value: totals => totals.count
                },
                {
                    header: 'Salg',
                    formatter: this.$options.filters.separator,
                    value: totals => totals.sales
                },
                {
                    header: 'Salg pr. emne',
                    formatter: this.$options.filters.separator,
                    value: totals => totals.count ? totals.total / totals.count : totals.total
                },
                {
                    header: 'Solgt præmie',
                    formatter: this.$options.filters.separator,
                    value: totals => totals.total
                },
                {
                    header: 'Gns. præmie',
                    formatter: this.$options.filters.separator,
                    value: totals => totals.sales ? totals.total / totals.sales : totals.total
                },
                {
                    header: 'Hitrate',
                    formatter: this.$options.filters.percentage,
                    value: totals => totals.count && totals.sales ? totals.sales / totals.count : totals.sales ? 1 : 0,
                }
            ],
            stats: null,
            fields: [
                {
                    header: 'Afsl.',
                    field: 'count',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Salg',
                    field: 'sales',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'HR',
                    field: 'hitrate',
                    cols: '2',
                    formatter: this.$options.filters.percentage
                },
                {
                    header: 'Solgt præmie',
                    field: 'total',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Gns. præmie',
                    field: 'avgSale',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Salg pr. emne',
                    field: 'avgLead',
                    cols: '2',
                    formatter: this.$options.filters.separator
                }
            ],
            valueFunctions: {
                'count': v => v.count,
                'sales': v => v.sales,
                'hitrate': v => v.count ? v.sales / v.count : !!v.sales * 1,
                'total': v => v.total,
                'avgSale': v => v.sales ? v.total / v.sales : v.total,
                'avgLead': v => v.count ? v.total / v.count : v.total
            },
            nestedFields: ['count', 'sales', 'total']
        }
    },
    computed: {
        totals () {
            return this.stats ? this.$reduceNested(this.stats, this.nestedFields) : {}
        },
        filteredRows () {
            return {
                firstRow: this.rows.filter(row => row.value !== this.secondRow),
                secondRow : this.rows.filter(row => row.value !== this.firstRow),
            }
        },
        range () {
            return this.$store.state.naestved.range
        },
        period () {
            return this.$store.state.naestved.period
        }
    },
    methods: {
        async getData () {
            this.loading = true
            const response = await this.$http().get('naestved', {
                params: {
                    startDate: this.range[0],
                    endDate: this.range[1],
                    firstKey: this.firstRow,
                    secondKey: this.secondRow
                }
            })
            this.stats = response.data
            this.loading = false
        },
        switchRows () {
            const tempFirstRow = this.firstRow
            this.firstRow = this.secondRow
            this.secondRow = tempFirstRow
        }
    },
    watch: {
        firstRow: function () {
            this.getData()
        },
        secondRow: function () {
            this.getData()
        },
		range: {
			handler({ length }) {
                if (length === 2) this.getData();
			},
			deep: true
        },
        period: function () {
		    this.$store.commit("naestved/setRange", this.$store.state.naestved.period);
        }
    },
    created () {
        this.getData()
    }
}
</script>